"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseInput = BaseInput;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const fit_element_height_1 = require("../helpers/fit-element-height");
const hooks_1 = require("../hooks");
const utils_1 = require("./utils");
const bind_1 = __importDefault(require("classnames/bind"));
const base_input_m_scss_1 = __importDefault(require("./base-input.m.scss"));
const cx = bind_1.default.bind(base_input_m_scss_1.default);
/**
 * Базовое поле ввода текста.
 * Позволяет выводить "остаточный placeholder".
 * Может выводиться в однострочном и многострочном режимах.
 * В многострочном режиме автоматически подстраивает высоту под введенный текст.
 * @param props Свойства.
 * @return Элемент.
 */
function BaseInput({ inputRef, textareaRef, style, className, restPlaceholder: restPlaceholderProp, 'data-testid': testId = 'base-input', ...props }) {
    const textareaInnerRef = (0, react_1.useRef)(null);
    const inputInnerRef = (0, react_1.useRef)(null);
    (0, react_1.useImperativeHandle)(textareaRef, () => textareaInnerRef.current);
    (0, react_1.useImperativeHandle)(inputRef, () => inputInnerRef.current);
    (0, hooks_1.useIsomorphicLayoutEffect)(() => {
        // ВАЖНО: после каждого render'а подгоняем высоту многострочного поля под содержимое
        if (textareaInnerRef.current) {
            (0, fit_element_height_1.fitElementHeight)({ target: textareaInnerRef.current });
        }
    });
    let field;
    if (props.multiline) {
        field = ((0, jsx_runtime_1.jsx)("textarea", { ...(0, utils_1.omitMultiline)(props), ref: textareaInnerRef, rows: props.rows ?? 1, "data-testid": 'base-input:field' // ВАЖНО: не даем переопределить data-test-id
            , className: cx('field', 'reset', 'multiline'), onInput: e => {
                props.onInput?.(e);
                (0, fit_element_height_1.fitElementHeight)({ target: e.currentTarget });
            } }));
    }
    else {
        field = ((0, jsx_runtime_1.jsx)("input", { ...(0, utils_1.omitMultiline)(props), ref: inputInnerRef, "data-testid": 'base-input:field' // ВАЖНО: не даем переопределить data-test-id
            , className: cx('field', 'reset') }));
    }
    let restPlaceholder = null;
    // скрываем rest placeholder для неконтролируемых полей
    if (typeof props.value !== 'undefined') {
        restPlaceholder =
            typeof restPlaceholderProp === 'string'
                ? { shiftValue: String(props.value), value: restPlaceholderProp }
                : { shiftValue: String(props.value), value: '', ...restPlaceholderProp };
    }
    return ((0, jsx_runtime_1.jsxs)("div", { style: style, className: cx('reset', 'root', className), "data-testid": testId, children: [!props.multiline && restPlaceholder && restPlaceholder.value && ((0, jsx_runtime_1.jsxs)("span", { "aria-hidden": true, className: cx('rest-placeholder'), children: [(0, jsx_runtime_1.jsx)("span", { "data-testid": 'rest-placeholder-shift', className: cx('shift-part'), children: restPlaceholder.shiftValue }), (0, jsx_runtime_1.jsx)("span", { "data-testid": 'rest-placeholder', className: cx('main-part'), children: restPlaceholder.value })] })), field] }));
}
//# sourceMappingURL=base-input.js.map